/**
 * Miniaturas de la galería de la ficha de la home.
 * Sin JS se ve la primera imagen y las miniaturas no hacen nada: el contenido sigue ahí.
 */
document.addEventListener('click', (evento) => {
  const mini = evento.target.closest('.kotashi-ficha__mini');
  if (!mini) return;

  const galeria = mini.closest('.kotashi-ficha__galeria');
  if (!galeria) return;

  const indice = mini.dataset.indice;

  for (const boton of galeria.querySelectorAll('.kotashi-ficha__mini')) {
    const activo = boton === mini;
    boton.classList.toggle('is-activo', activo);
    boton.setAttribute('aria-selected', String(activo));
  }

  for (const marco of galeria.querySelectorAll('.kotashi-ficha__marco')) {
    marco.classList.toggle('is-oculto', marco.dataset.marco !== indice);
  }
});
